import React from 'react';

const AssetFormFields = ({ assetForm, setAssetForm, buildings, buildingsLoading, buildingsError }) => (
  <div className="space-y-4">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Asset Name *</label>
      <input type="text" value={assetForm.name}
        onChange={e => setAssetForm({ ...assetForm, name: e.target.value })}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
        placeholder="Enter asset name" />
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Asset Tag</label>
      <input type="text" value={assetForm.asset_tag}
        onChange={e => setAssetForm({ ...assetForm, asset_tag: e.target.value })}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
        placeholder="Auto-generated if empty" />
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
      <textarea value={assetForm.description}
        onChange={e => setAssetForm({ ...assetForm, description: e.target.value })}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
        rows="3" placeholder="Enter description" />
    </div>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
        <input type="text" value={assetForm.location}
          onChange={e => setAssetForm({ ...assetForm, location: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
          placeholder="Building, Room" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
        <input type="text" value={assetForm.category}
          onChange={e => setAssetForm({ ...assetForm, category: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
          placeholder="Equipment type" />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Manufacturer</label>
        <input type="text" value={assetForm.manufacturer}
          onChange={e => setAssetForm({ ...assetForm, manufacturer: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
          placeholder="Brand/Manufacturer" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Model</label>
        <input type="text" value={assetForm.model}
          onChange={e => setAssetForm({ ...assetForm, model: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
          placeholder="Model number" />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Serial Number</label>
        <input type="text" value={assetForm.serial_number}
          onChange={e => setAssetForm({ ...assetForm, serial_number: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
          placeholder="Serial number" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Assigned To</label>
        <input type="text" value={assetForm.assigned_to}
          onChange={e => setAssetForm({ ...assetForm, assigned_to: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
          placeholder="Responsible person" />
      </div>
    </div>

    {/* Property Assignment */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Assign to Property *</label>
      {buildingsLoading ? (
        <div className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 flex items-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-400 mr-2"></div>
          <span className="text-gray-500 text-sm">Loading properties...</span>
        </div>
      ) : (
        <select value={assetForm.building_id || ""}
          onChange={e => setAssetForm({ ...assetForm, building_id: e.target.value || null })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
          required>
          <option value="">Select a property...</option>
          {buildings.map(b => (
            <option key={b.id} value={b.id}>{b.buildingName} ({b.city || "No City"})</option>
          ))}
        </select>
      )}
      {buildingsError && <p className="text-sm text-red-600 mt-1">{buildingsError}</p>}
      <p className="text-xs text-gray-500 mt-1">Required: Select the property where this asset will be located.</p>
    </div>
  </div>
);

export default AssetFormFields;
